import React, { useRef, useState, useEffect } from "react";
import productsData from '../productData';
import infrastructure from '../../Images/infrastructure-img.svg';
import './Products.css';
import { useNavigate } from 'react-router-dom';
import slandinguparrow from '../../Images/slanding-up-arrow.svg';

const Products = () => {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage, setProductsPerPage] = useState(9);
    const [selectedPdf, setSelectedPdf] = useState(null);
    const scrollTargetRef = useRef(null);
    const navigate = useNavigate();

    const isInitialMount = useRef(true);

    useEffect(() => {
        setCurrentPage(1);
        if (selectedCategory === "All") {
            setFilteredProducts(productsData);
        } else {
            const filtered = productsData.filter(
                (product) =>
                    (product.category && product.category.includes(selectedCategory)) || product.category === selectedCategory
            );
            setFilteredProducts(filtered);
        }
    }, [selectedCategory, productsPerPage]);

    const indexOfLastProduct = currentPage * productsPerPage;
    const indexofFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = filteredProducts.slice(indexofFirstProduct, indexOfLastProduct);
    const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (scrollTargetRef.current) {
                const navbarHeight = 80; 
                const yOffset = scrollTargetRef.current.getBoundingClientRect().top + window.scrollY - navbarHeight;

                window.scrollTo({ top: yOffset, behavior: 'smooth' });
            }
        }
    }, [currentPage]); 


    const handleDropdownChange = (e) => {
        setProductsPerPage(Number(e.target.value));
        setCurrentPage(1);
    }

    const renderPagination = () => {
        const pages = [];

        const addPage = (page) => {
            pages.push(
                <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`pagination-btn ${currentPage === page ? "active" : ""}`}
                >
                    {page}
                </button>
            );
        };

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                addPage(i);
            }
        } else {
            addPage(1);
            if (currentPage > 3) {
                pages.push(<span key="start-ellipsis" className="pagination-ellipsis">...</span>);
            }
            let start = Math.max(2, currentPage - 1);
            let end = Math.min(totalPages - 1, currentPage + 1);
            for (let i = start; i <= end; i++) {
                addPage(i);
            }
            if (currentPage < totalPages - 2) {
                pages.push(<span key="end-ellipsis" className="pagination-ellipsis">...</span>);
            }
            addPage(totalPages);
        }

        return pages;
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (selectedPdf) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [selectedPdf]);


    return (
        <>
            <div className="product-top-container">
                <div className="product-text-wrapper">
                    <h2 className="product-title"><span className="product-title-highlight">Explore Our</span> Wide Range of <span className="product-title-highlight">Products</span></h2>
                    <h4 className="product-subtitle">Discover our extensive selection of products tailored to meet diverse needs. From high-performance tools to reliable everyday essentials, we’ve got you covered.</h4>
                </div>
                <div className="infrastructure-img-wrapper">
                    <img src={infrastructure} alt="infrastructure" className="infrastructure-img"/>
                </div>
            </div>
            
            <div className="product-middle-container" ref={scrollTargetRef}>
                <div className="productdata-button-container">
                    <div className="category-area">
                        <div className="category-buttons-wrapper">
                        {["All", "Patient Monitoring Systems", "Emergency & Cardiac Care", "Hospital Furniture"].map((category) => (
                            <button
                                key={category}
                                className={`category-btn ${selectedCategory === category ? "active" : ""}`}
                                onClick={() => setSelectedCategory(category)}
                            >
                                {category}
                            </button>
                        ))}
                        </div>
                    </div>

                    <div className="dropdown-container">
                        <label className="show-text" htmlFor="productsPerPage">Show: </label>
                        <select
                            id="productsPerPage"
                            value={productsPerPage}
                            onChange={handleDropdownChange}
                            className="dropdown-select"
                        >
                            <option className="dropdown-value" value="9">9</option>
                            <option className="dropdown-value" value="27">27</option>
                            <option className="dropdown-value" value="60">60</option>
                        </select>
                        <span className="items-per-page"> items per page</span>
                    </div>
                </div>

                <div className="products-container">
                    {currentProducts.map((product, index) => (
                        <div className="product-card" key={index}>
                            <div className="product-image-wrapper">
                                <img src={product.image} alt={product.name} className="product-image" />
                                <div className="product-info-card">
                                    <div className="product-info-card-container">
                                        <div className="product-card-details">
                                            <h4 className="product-name-text">{product.name}</h4>
                                            <p className="description-text">
                                                {product.description.length > 200 ? `${product.description.slice(0, 35)}... ` : product.description}
                                                {product.description.length > 100 && (
                                                    <span className="read-more-link" onClick={() => setSelectedPdf(product.pdf)}>
                                                        more
                                                    </span>
                                                )}
                                            </p>
                                        </div>
                                        <div className="arrow-container">
                                            <div className="arrow-display">
                                                <span
                                                    className="slanding-up-arrow"
                                                    onClick={() => setSelectedPdf(product.pdf)}
                                                    role="button">
                                                    <img src={slandinguparrow} alt='arrow' className="slanding-up-arrow-img" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="bottom-controls-row">
                    {totalPages >= 1 &&  ( 
                    <div className="pagination-container">
                        {renderPagination()}
                    </div>
                    )}
                </div>
            </div>

            {selectedPdf && (
              <div className="pdf-overlay">
                <div className="pdf-frame-container">
                  <div className="pdf-toolbar">
                    <button onClick={() => setSelectedPdf(null)} className="pdf-close-button" aria-label="Close PDF">
                      <i className="bi bi-x-lg" />
                    </button>
                  </div>
                  <iframe
                    src={selectedPdf}
                    className="pdf-iframe"
                    title="Product PDF"
                  />
                </div>
              </div>
            )}
        </>
    )
}

export default Products;